var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return !_vm.switchView
    ? _c(
        "v-row",
        { staticClass: "linha-acc" },
        [
          _c("v-col", { staticClass: "coluna", attrs: { md: "2", xs: "12" } }, [
            _c("div", { staticClass: "descricao title-desc" }, [
              _c("span", [_vm._v(" " + _vm._s(_vm.item.title) + " ")])
            ])
          ]),
          _c(
            "v-col",
            {
              staticClass: "coluna",
              attrs: { md: "1", xs: "12", title: _vm.totalParticipacao }
            },
            [
              _c("div", { staticClass: "descricao hide" }, [
                _c("span", [
                  _vm._v(
                    " " +
                      _vm._s(
                        _vm.percentageHelper.formatPercentage(
                          _vm.totalParticipacao
                        )
                      ) +
                      " "
                  )
                ])
              ])
            ]
          ),
          _c("v-col", { staticClass: "coluna", attrs: { md: "2", xs: "12" } }, [
            _c("div", { staticClass: "descricao hide" }, [_c("span")])
          ]),
          _c("v-col", { staticClass: "coluna", attrs: { md: "2", xs: "12" } }, [
            _c("div", { staticClass: "descricao hide" }, [_c("span")])
          ]),
          _c("v-col", { staticClass: "coluna", attrs: { md: "1", xs: "12" } }, [
            _c("div", { staticClass: "descricao hide" }, [_c("span")])
          ]),
          _c("v-col", { staticClass: "coluna", attrs: { md: "2", xs: "12" } }, [
            _c("div", { staticClass: "descricao hide" }, [_c("span")])
          ]),
          _c(
            "v-col",
            {
              staticClass: "coluna",
              attrs: { md: "2", xs: "12", title: _vm.totalSaldo }
            },
            [
              _c("div", { staticClass: "descricao" }, [
                _c("span", [
                  _vm._v(
                    " " +
                      _vm._s(_vm.currencyHelper.formatValue(_vm.totalSaldo)) +
                      " "
                  )
                ])
              ])
            ]
          )
        ],
        1
      )
    : _c(
        "v-row",
        { staticClass: "linha-2-acc" },
        [
          _c(
            "v-col",
            {
              staticClass: "coluna",
              style: _vm.color,
              attrs: { md: "2", xs: "12" }
            },
            [
              _c(
                "v-col",
                {
                  staticClass: "coluna",
                  style: _vm.color,
                  attrs: { md: "10", xs: "12" }
                },
                [
                  _c("div", { staticClass: "descricao title-desc" }, [
                    _c("span", [_vm._v(" " + _vm._s(_vm.item.title) + " ")])
                  ])
                ]
              ),
              _c(
                "v-col",
                {
                  staticClass: "coluna",
                  style: _vm.color,
                  attrs: { md: "2", xs: "12" }
                },
                [
                  _c("div", { staticClass: "descricao title-desc" }, [
                    _c("span", [
                      _vm._v(
                        " " +
                          _vm._s(
                            _vm.percentageHelper.formatPercentage(
                              _vm.totalParticipacao
                            )
                          ) +
                          " "
                      )
                    ])
                  ])
                ]
              )
            ],
            1
          ),
          _c(
            "v-col",
            {
              staticClass: "coluna coluna-composta",
              attrs: { md: "1", xs: "12", title: _vm.totalSaldo }
            },
            [
              _c("div", { staticClass: "descricao" }, [
                _c("span", [
                  _vm._v(
                    " " +
                      _vm._s(_vm.currencyHelper.formatValue(_vm.totalSaldo)) +
                      " "
                  )
                ])
              ])
            ]
          ),
          _c(
            "v-col",
            {
              staticClass: "coluna coluna-composta",
              attrs: { md: "3", xs: "12" }
            },
            [
              _c(
                "div",
                { staticClass: "colunas" },
                [
                  _c(
                    "v-row",
                    [
                      _c(
                        "v-col",
                        {
                          staticClass: "column hide",
                          attrs: { md: "3", xs: "12", title: _vm.mensalGanho }
                        },
                        [
                          _c("div", { staticClass: "hide" }, [
                            _c("span", [_vm._v(_vm._s(_vm.mensalGanho))])
                          ])
                        ]
                      ),
                      _c(
                        "v-col",
                        {
                          staticClass: "column hide",
                          attrs: { md: "3", xs: "12", title: _vm.mensalPercent }
                        },
                        [
                          _c("div", [
                            _c("span", [_vm._v(_vm._s(_vm.mensalPercent))])
                          ])
                        ]
                      ),
                      _c(
                        "v-col",
                        {
                          staticClass: "column hide",
                          attrs: { md: "6", xs: "12", title: _vm.mensalValor }
                        },
                        [
                          _c("div", [
                            _c("span", [_vm._v(_vm._s(_vm.mensalValor))])
                          ])
                        ]
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ]
          ),
          _c(
            "v-col",
            {
              staticClass: "coluna coluna-composta",
              attrs: { md: "3", xs: "12" }
            },
            [
              _c(
                "div",
                { staticClass: "colunas" },
                [
                  _c(
                    "v-row",
                    [
                      _c(
                        "v-col",
                        {
                          staticClass: "column hide",
                          attrs: { md: "3", xs: "12", title: _vm.dozeGanho }
                        },
                        [
                          _c("div", {}, [
                            _c("span", [_vm._v(_vm._s(_vm.dozeGanho))])
                          ])
                        ]
                      ),
                      _c(
                        "v-col",
                        {
                          staticClass: "column hide",
                          attrs: { md: "3", xs: "12", title: _vm.dozePercent }
                        },
                        [_c("div", [_c("span", [_vm._v(_vm._s(""))])])]
                      ),
                      _c(
                        "v-col",
                        {
                          staticClass: "column hide",
                          attrs: { md: "6", xs: "12", title: _vm.dozeValor }
                        },
                        [
                          _c("div", [
                            _c("span", [_vm._v(_vm._s(_vm.dozeValor))])
                          ])
                        ]
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ]
          ),
          _c(
            "v-col",
            {
              staticClass: "coluna coluna-composta",
              attrs: { md: "3", xs: "12" }
            },
            [
              _c(
                "div",
                { staticClass: "colunas" },
                [
                  _c(
                    "v-row",
                    [
                      _c(
                        "v-col",
                        {
                          staticClass: "column hide",
                          attrs: { md: "3", xs: "12", title: _vm.geralGanho }
                        },
                        [
                          _c("div", {}, [
                            _c("span", [
                              _vm._v(
                                _vm._s(
                                  _vm.percentageHelper.formatPercentage(
                                    _vm.geralGanho
                                  )
                                )
                              )
                            ])
                          ])
                        ]
                      ),
                      _c(
                        "v-col",
                        {
                          staticClass: "column hide",
                          attrs: { md: "3", xs: "12", title: _vm.geralPercent }
                        },
                        [_c("div", [_c("span", [_vm._v(_vm._s(""))])])]
                      ),
                      _c(
                        "v-col",
                        {
                          staticClass: "column hide",
                          attrs: { md: "6", xs: "12", title: _vm.geralValor }
                        },
                        [
                          _c("div", [
                            _c("span", [
                              _vm._v(
                                _vm._s(
                                  _vm.currencyHelper.formatValue(_vm.geralValor)
                                )
                              )
                            ])
                          ])
                        ]
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ]
          )
        ],
        1
      )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }